import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import {db, auth, FieldValue} from '@/firebase'
import router from '@/router'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLogin: false,
    markers: [],
    errorMessage: "",
    message: "",
    uid: null,
    isGuest: false,
    user: null,
    userData: null,
    linkEmail: "",
    lang: "en",
    siteClosed: true,
    siteClosedMapDisabled: false,
  },
  getters: {
    loginId: state => {
      return state.user.uid;
    },
    userData: (state, getters) => {
      if (state.userData && state.userData.length == 1) {
        return state.userData[0]
      } else {
        return null;
      }
    },
    isAdmin: (state, getters) => {
      return getters.userData && getters.userData.admin;
    }
  },
  mutations: {
    toggleLang(state, payload) {
      if (state.lang == 'jp') {state.lang = 'en'}
      else if (state.lang == 'en') {state.lang = 'jp'}
    },
    loginState(state, payload){
      const user = payload.user;
      if (user) {
        state.isLogin = true;
        state.username = user.displayName ? user.displayName : user.email;
        state.errorMessage = "";
        state.uid = user.uid;
        state.isGuest = user.isAnonymous;
        state.user = user;
        if (!state.isGuest) {
          store.dispatch('bindUserData', {'uid':user.uid});
        }
        store.dispatch('bindMarkers');
        //router.push({name:'home'});
      } else {
        state.user = null;
        state.isLogin = false;
        state.username = "";
        state.errorMessage = payload.error;
        store.dispatch('unbindMarkers');
        //router.push({name:'home'});
      }
    },
    message(state, payload){
      state.message = payload.message;
    },
    errorMessage(state, payload) {
      state.errorMessage = payload.message;
    },
    loadEmail(state, payload) {
      state.linkEmail = window.localStorage.getItem('emailForSignIn');
    },
    ...vuexfireMutations
  },
  actions: {
    sendSignUpEmail (context, payload) {
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be whitelisted in the Firebase Console.
        url: location.origin + router.resolve({name: 'signup'}).href,
        // This must be true.
        handleCodeInApp: true,
      };
      auth.sendSignInLinkToEmail(payload.email, actionCodeSettings)
        .then(function(result) {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem('emailForSignIn', payload.email);
          store.commit("message", {message:'SignUp email was successfully sent.'})
        })
        .catch(function(error) {
          // Some error occurred, you can inspect the code: error.code
          store.commit("errorMessage", {message:error.message});
        });
    },

    loadEmail(context, payload) {
      store.commit("loadEmail");
    },

    async createAccount (context, payload) {
      if (payload.password != payload.passwordCheck) {
        store.commit("loginState", {error: 'password is not matched.'});
        return;
      }

      if (auth.isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.

        //console.log(auth.currentUser);
        auth.signInWithEmailLink(payload.email, window.location.href)
          .then(function(result) {
            // Clear email from storage.
            window.localStorage.removeItem('emailForSignIn');
            result.user.updatePassword(payload.password).then(function(result) {
            console.log(result);
          }).catch(function(error) {
            store.commit("errorMessage", {message:error.message});
            console.log(error);
          });

          store.dispatch('saveUserProfile', {name:payload.name});

          router.push({name:'home'});
          
          // You can access the new user via result.user
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser
        })
        .catch(function(error) {
          store.commit("errorMessage", {message:error.message});
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
        });
      }
    },

    async createAccountWithPassword (context, payload) {
      await auth.createUserWithEmailAndPassword(payload.email, payload.password)
        .then(function(result) {
          db.collection('users').add({
            name: payload.name,
            authUid: result.user.uid,
          }).then(function(result) {
          }).catch(function(error) {
            console.log(error);
          });
        }).catch(function(error) {
          store.commit("loginState", {error: error.message});
        });
    },

    saveUserProfile (context, payload) {
      db.collection('users').add({
        name: payload.name,
        authUid: auth.currentUser.uid,
        createdAt: FieldValue.serverTimestamp(),
      }).then(function(result) {
        console.log(result);
      }).catch(function(error) {
        console.log(error);
      });
    },

    login (context, payload) {
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(function(result) {
        }).catch(function(error) {
          store.commit("loginState", {error: error.message});
        });
    },
    loginGuest (context, payload) {
        auth.signInAnonymously()
          .then(function(result) {
            store.commit("loginState", {user: result.user});
          }).catch(function(error) {
            store.commit("loginState", {error: error.message});
          });
    },
    logout (context) {
      auth.signOut().then(()=>{
      })
      .catch((error)=>{
        console.log(error);
      });
    },
    bindMarkers: firestoreAction((context) => {
      //return context.bindFirestoreRef('markers', db.collection('markers'))
      return context.bindFirestoreRef('markers', db.collection('markers'))
    }),
    unbindMarkers: firestoreAction((context) => {
      context.unbindFirestoreRef('markers')
    }),
    bindUserData: firestoreAction((context, payload) => {
      return context.bindFirestoreRef('userData', db.collection('users').where('authUid', '==', payload.uid));
    }),
  },
  modules: {
  }
})

auth.onAuthStateChanged(function(user) {
  store.commit("loginState", {user: user});
});

export default store
